import { useEffect, useState } from "react";
import API from "../../lib/api";
import { Flask, FilePdf } from "@phosphor-icons/react";
import { openAuthFile } from "../../lib/fileOpen";

/** Operative portal: the substances in use with the issued COSHH assessment and product data sheet to read before first use. */
export default function OperativeCoshhCard() {
  const [subs, setSubs] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { API.get("/in-house-portal/coshh").then(({ data }) => setSubs(data.substances || [])).catch(() => setSubs([])); }, []);
  if (!subs?.length) return null;
  const shown = open ? subs : subs.slice(0, 4);
  return (
    <section className="bg-card border border-border rounded-lg p-4" data-testid="operative-coshh-card">
      <div className="flex items-center gap-2 mb-2">
        <Flask size={18} className="text-amber-600" />
        <h3 className="font-semibold text-sm flex-1">COSHH — substances we use</h3>
        <span className="text-[11px] text-muted-foreground">{subs.length}</span>
      </div>
      <ul className="divide-y divide-border">
        {shown.map(s => (
          <li key={s.id} className="py-2 flex items-start gap-2" data-testid={`operative-coshh-${s.id}`}>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium leading-tight">{s.product}<span className="text-muted-foreground text-xs font-normal">{s.manufacturer ? ` · ${s.manufacturer}` : ""}</span></p>
              <p className="text-[11px] text-muted-foreground truncate">{s.hazard_line}{s.ppe?.length ? ` · PPE: ${s.ppe.slice(0, 3).join(", ")}` : ""}</p>
            </div>
            <div className="flex gap-1 shrink-0">
              {s.assessment_file_id && <button type="button" className="text-[11px] inline-flex items-center gap-1 px-2 py-1 rounded border border-border hover:bg-muted" onClick={() => openAuthFile(`/files/${s.assessment_file_id}/preview`)} data-testid={`operative-coshh-assessment-${s.id}`}><FilePdf size={12} /> Assessment</button>}
              {s.data_sheet_file_id && <button type="button" className="text-[11px] inline-flex items-center gap-1 px-2 py-1 rounded border border-border hover:bg-muted" onClick={() => openAuthFile(`/files/${s.data_sheet_file_id}/preview`)} data-testid={`operative-coshh-datasheet-${s.id}`}><FilePdf size={12} /> Data sheet</button>}
            </div>
          </li>
        ))}
      </ul>
      {subs.length > 4 && <button type="button" className="text-xs underline text-muted-foreground mt-1" onClick={() => setOpen(o => !o)}>{open ? "Show fewer" : `Show all ${subs.length}`}</button>}
    </section>
  );
}
